import * as React from 'react';
import * as intl from "react-intl-universal";
import { AutoComplete, Form } from 'antd';
import StaticView from '../Form/Field/StaticView';
const Option = AutoComplete.Option;

export default class Match extends React.Component<any> {
    static fieldName = 'match';
    static type = 'Input';
    timeout: any;
    state: any = {
        options: []
    };
    /**
     * 值变化控制
     * @param value
     */
    onChangeHandler = (value: any) => {
        const { onChange, callback, role, serverId, filter } = this.props;
        // 调取列表，更新option
        if (callback && value) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.timeout = setTimeout(() => {
                this.setState({ options: [] }, () => {
                    this.updateOptions(value, callback, role, serverId, filter);
                });
            }, 300);
        }
        if (onChange) onChange(value);
    };

    /**
     * 更新options
     */
    updateOptions = (value: any, callback: Function, type?: string | Array<string>, serverId?: string, filter?: string) => {
        callback({
            uname: value,
            page: 1,
            pagesize: 20,
            serverId: serverId,
            filter,
            ...(type ? { utype: Array.isArray(type) ? type : [type] } : {})
        }).then(({ data }: any) => {
            const source = data.length ? data : data.concat([{
                uuid: 'None',
                firstName: 'Search',
                lastName: 'nothing',
                disabled: true
            }]);
            this.setState({ options: this.formatOption(source) });
        }).catch();
    };

    /**
     * 格式化options
     */
    formatOption = (options: any) => {
        return options.map(({ uuid, lastname, firstname, disabled }: any) => ({
            label: `${intl.get('Global.Name', {
                firstName: firstname,
                lastName: lastname
            })} (${uuid})`,
            value: uuid,
            disabled: disabled
        }));
    };

    /**
     * 选择控制
     * @param value
     */
    onSelectHandler = (value: any) => {
        const { onSelect } = this.props;
        if (onSelect) onSelect(value);
    };
    /**
     * 静态数据展示处理
     * @param val
     */
    adaptHandler = (val: any) => {
        const { options } = this.state;
        const { defaultInfo } = this.props;
        defaultInfo && defaultInfo.uuid && !options.filter(({ value }: any) => value == defaultInfo.uuid).length && options.push({
            label: `${intl.get('Global.Name', {
                firstName: defaultInfo.firstname,
                lastName: defaultInfo.lastname
            })} (${defaultInfo.uuid})`,
            value: defaultInfo.uuid
        });
        const display = options && options.filter(({ value }: any) => (val || []).includes(value));
        return (display && display.length) && display[0].label;
    };
    /**
     * 失焦控制
     */
    onBlurHandler = () => {
        // 账户存在校验
        const { onBlur, value } = this.props;
        if (onBlur) onBlur(value);
    };

    render() {
        const { inputKey, normalizeInput, placeholder, disabled, staticView, initialValue, value, defaultInfo,
            link, readOnly, style, showUuid, callback, nameConfig, showName } = this.props;
        const { options } = this.state;
        const defaultLabel = showName
            ? defaultInfo
                ? `${intl.get('Global.Name', {
                    firstName: defaultInfo.firstname,
                    lastName: defaultInfo.lastname
                })} (${defaultInfo.uuid})`
                : initialValue
            : value || initialValue;
        return (
            (staticView && disabled || readOnly)
                ? <StaticView display={value} link={link} nameConfig={nameConfig} showName={showName} adaptFn={this.adaptHandler}/>
                : <Form.Item name={inputKey} normalize={(value: any) => normalizeInput(value, inputKey)} >
                    <AutoComplete onChange={this.onChangeHandler} style={style || {}}
                        onSelect={this.onSelectHandler}
                        onBlur={this.onBlurHandler}
                        placeholder={placeholder}
                        disabled={disabled}
                        allowClear={true}
                        defaultActiveFirstOption={false}
                        defaultValue={defaultLabel}
                        filterOption={false}>
                        {callback && options.map((item: any, index: number) => {
                            return <Option key={`v4-match-${index}`} value={showUuid ? item.value : item.label}
                                disabled={item.disabled}>
                                {item.label}
                            </Option>;
                        })}
                    </AutoComplete>
                </Form.Item>
        );
    }
}
